import {cn} from '../../lib/utils';
import {Typography} from '../Typography';

import type {ComponentProps} from 'react';

export interface SectionDividerProps extends ComponentProps<'div'> {
  title: string;
}

/** A small caps-style label followed by a rule filling the remaining width — groups a run of fields under a named subsection. */
export function SectionDivider({title, className, ...props}: SectionDividerProps) {
  return (
    <div
      data-slot="section-divider"
      className={cn('flex items-center gap-2.5', className)}
      {...props}
    >
      <Typography
        size="xs"
        weight="semibold"
        color="tertiary"
        className="whitespace-nowrap tracking-wider"
      >
        {title}
      </Typography>
      <hr className="flex-1 border-t border-border-subtle" />
    </div>
  );
}
